export const state = () => ({
    areTranslationKeysVisible: false,
    isGridOverlayVisible: false,
    scrollY: 0,
});

export const mutations = {
    setIsGridOverlayVisible(state, payload) {
        state.isGridOverlayVisible = payload;
    },
    setAreTranslationKeysVisible(state, payload) {
        state.areTranslationKeysVisible = payload;
    },
    setScrollY(state, payload) {
        state.scrollY = payload;
    },
};
